<div class="mx-auto flex max-w-5xl flex-col gap-6 p-4 md:p-8">
  <div>
    <h1 class="text-3xl font-bold">Buy DES Credits</h1>
    @if (isAdminPurchase) {
      <p class="mt-2 text-base-content/70">
        Purchasing for tenant {{ targetTenantId }}, registration
        {{ targetRegistrationId }}.
      </p>
    }
    @if (adminPurchaseDenied) {
      <p class="mt-2 text-error">
        Only admins can purchase DES credits for another tenant.
      </p>
    }
    @if (resolvingTarget) {
      <p class="mt-2 text-base-content/70">Confirming DES credit record...</p>
    }
  </div>

  @if (!resolvingTarget) {
  <div class="card border border-base-300 bg-base-100 shadow-sm">
    <div class="card-body gap-8">
      <div class="grid gap-3 md:grid-cols-3">
        @for (tier of tiers; track tier.minimum) {
          <div
            class="cursor-pointer rounded-lg border p-4 transition-colors"
            [class.border-primary]="selectedTier === tier"
            [class.bg-primary]="selectedTier === tier"
            [class.text-primary-content]="selectedTier === tier"
            [class.border-base-300]="selectedTier !== tier"
            (click)="selectTier(tier)"
          >
            <p class="text-sm font-medium opacity-75">
              {{ tier.minimum | number }}
              @if (tier.maximum) {
                - {{ tier.maximum | number }}
              } @else {
                + records
              }
            </p>
            <p class="mt-1 text-2xl font-bold">
              {{ tier.pricePerThousand | currency }}
            </p>
            <p class="text-sm opacity-75">per 1,000 records</p>
          </div>
        }
      </div>

      <div>
        <div class="mb-3 flex items-end justify-between gap-4">
          <label for="des-credit-slider" class="self-center font-semibold">
            Number of credits
          </label>
          <input
            #creditInput
            id="des-credit-input"
            type="number"
            class="input input-bordered h-9 w-28"
            [min]="minimumCredits"
            [max]="maximumCredits"
            step="any"
            [value]="credits"
            (change)="setCredits(creditInput.value, creditInput)"
          />
        </div>

        <input
          id="des-credit-slider"
          type="range"
          class="des-credit-slider range range-primary w-full"
          [min]="creditIncrement"
          [max]="maximumCredits"
          [step]="creditIncrement"
          [value]="credits"
          (input)="setCreditsFromSlider($any($event.target).value)"
          aria-label="Number of DES credits"
        />

        <div class="mt-2 text-xs text-base-content/65">
          <div class="relative mt-1 h-8">
            <span
              class="absolute -top-3 left-[6%] h-3 w-px bg-base-content/20"
            ></span>
            <span class="absolute left-[6%] text-left">
              250,001<br />$0.85 / 1k
            </span>
            <span
              class="absolute -top-3 left-[40%] h-3 w-px bg-base-content/20"
            ></span>
            <span class="absolute left-[40%] text-left">
              2,000,001<br />$0.65 / 1k
            </span>
          </div>
        </div>
      </div>

      <div class="grid items-end gap-6 md:grid-cols-2">
        <div></div>
        <div class="rounded-lg bg-base-200 p-5">
          <div class="flex justify-between gap-4">
            <span>Credits</span>
            <strong>{{ credits | number }}</strong>
          </div>
          <div class="mt-2 flex justify-between gap-4">
            <span>Price per 1,000</span>
            <strong>{{ selectedTier.pricePerThousand | currency }}</strong>
          </div>
          <div class="divider my-2"></div>
          <div class="flex items-center justify-between gap-4 text-xl">
            <span>Total</span>
            <strong>{{ total | currency }}</strong>
          </div>
        </div>
      </div>

      <div class="flex justify-end">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="!canContinue"
          (click)="continueToCheckout()"
        >
          @if (creatingPurchase) {
            Processing...
          } @else {
            Continue to payment
          }
        </button>
      </div>
      @if (createError) {
        <p class="mt-2 text-right text-error">{{ createError }}</p>
      }
    </div>
  </div>
  }
</div>
